import type { Media, Theme } from '../../types/props.js'

export interface ImageTextFeatureItem {
  /** 功能图标 */
  icon: string
  /** 功能标题 */
  text: string
  /** 功能描述 */
  desc: string
}

export interface ImageTextFeatureProps {
  data: {
    /** 主标题 */
    title: string
    /** 副标题 */
    subtitle?: string
    /** PC端图片 */
    pcImage: Media
    /** 移动端图片 */
    mobileImage: Media
    /** 平板端图片 */
    padImage?: Media
    /** 功能项列表 */
    items: ImageTextFeatureItem[]
    /** 图片位置，默认 left */
    imagePosition?: 'left' | 'right'
    /** 主题，默认 light */
    theme?: Theme
  }
  /** 自定义类名 */
  className?: string
  isHorizontal?: boolean
}
